import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import COLORS from '../../../../theme/Colors';

const QRCodeModal = ({ open, onClose, url, serviceName }) => {
    const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(url)}`;

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{
                sx: { borderRadius: '16px', p: 1, maxWidth: '400px', width: '90%' }
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: COLORS.secondary }}>
                    Código QR del Servicio
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', py: 3 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
                    Escanea este código para acceder rápidamente a la información de: <br/>
                    <strong>{serviceName}</strong>
                </Typography>
                
                <Box 
                    sx={{ 
                        p: 2, 
                        bgcolor: '#f8f9fa', 
                        borderRadius: '20px', 
                        display: 'inline-block',
                        border: '1px solid #e9ecef',
                        mb: 3,
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <img 
                        src={qrUrl} 
                        alt="QR Code" 
                        style={{ width: '250px', height: '250px', display: 'block', borderRadius: '10px' }} 
                    />
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="caption" sx={{ display: 'block', color: 'text.disabled', wordBreak: 'break-all' }}>
                        {url}
                    </Typography>
                </Box>

                <Button 
                    variant="contained" 
                    startIcon={<DownloadIcon />}
                    onClick={() => window.open(qrUrl, '_blank')}
                    sx={{ 
                        bgcolor: COLORS.secondary,
                        color: 'white',
                        textTransform: 'none',
                        px: 4,
                        py: 1,
                        borderRadius: '10px',
                        fontWeight: 'bold',
                        '&:hover': { bgcolor: COLORS.primary }
                    }}
                >
                    Descargar Código QR
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default QRCodeModal;
